// extracted by mini-css-extract-plugin
export default {"removeButton":"SlackNotificationsViewsConfigStep_removeButton__jtjVS"};